import api from "./api";

// Cliente do assistente conversacional. CRUD via axios; o envio de mensagem usa
// fetch() para ler o streaming SSE token-a-token (axios não expõe o corpo em
// streaming no browser).
export const listConversations = () => api.get("/chat/conversations").then(r => r.data);

export const createConversation = greeting =>
  api.post("/chat/conversations", greeting ? { greeting } : {}).then(r => r.data);

export const getMessages = id => api.get(`/chat/conversations/${id}/messages`).then(r => r.data);

export const deleteConversation = id => api.delete(`/chat/conversations/${id}`);

// ligação de demonstração: a IA liga e conversa. A ligação roda no backend; o
// front dispara e acompanha o status/transcrição por polling.
// to: número; task (opcional): objetivo da ligação ad-hoc (a IA liga em nome do
// usuário); conversationId (opcional): conversa de origem (o resultado volta lá).
export const placeCall = (to, task, conversationId) =>
  api
    .post("/chat/call", { to, ...(task ? { task } : {}), ...(conversationId ? { conversationId } : {}) })
    .then(r => r.data);

export const getCallStatus = sessionId => api.get(`/chat/call/${sessionId}`).then(r => r.data);

// Envia uma mensagem e faz streaming da resposta. Chama onDelta(text) a cada
// pedaço e onDone({title}) ao final. Retorna uma função para abortar.
export const streamMessage = (id, content, { onDelta, onDone, onError, onAsk } = {}) => {
  const controller = new AbortController();
  const auth = (api.defaults.headers && api.defaults.headers.Authorization) || "";

  (async () => {
    try {
      const res = await fetch(`/api/chat/conversations/${id}/messages`, {
        method: "POST",
        headers: { "Content-Type": "application/json", ...(auth ? { Authorization: auth } : {}) },
        credentials: "include",
        body: JSON.stringify({ content }),
        signal: controller.signal,
      });
      if (!res.ok || !res.body) {
        let msg = "Falha ao responder.";
        try {
          const j = await res.json();
          if (j && j.error) msg = j.error;
        } catch (e) {
          /* ignore */
        }
        throw new Error(msg);
      }

      const reader = res.body.getReader();
      const dec = new TextDecoder();
      let buf = "";
      for (;;) {
        // eslint-disable-next-line no-await-in-loop
        const { value, done } = await reader.read();
        if (done) break;
        buf += dec.decode(value, { stream: true });
        let nl;
        // eventos SSE separados por linha "data: {json}"
        while ((nl = buf.indexOf("\n")) >= 0) {
          const line = buf.slice(0, nl).trim();
          buf = buf.slice(nl + 1);
          if (!line.startsWith("data:")) continue;
          const payload = line.slice(5).trim();
          if (!payload) continue;
          try {
            const j = JSON.parse(payload);
            if (j.delta && onDelta) onDelta(j.delta);
            else if (j.ask && onAsk) onAsk(j.ask);
            else if (j.error) throw new Error(j.error);
            else if (j.done && onDone) onDone(j);
          } catch (e) {
            if (e.message && onError) onError(e);
          }
        }
      }
    } catch (err) {
      if (err.name !== "AbortError" && onError) onError(err);
    }
  })();

  return () => controller.abort();
};
